export default {
	favorite_delete_dialog_cancel: 'Abbrechen',
	favorite_delete_dialog_confirm: 'Löschen',
	favorite_delete_dialog_message: 'Möchten Sie diesen Shortcut wirklich löschen?',
	favorite_delete_dialog_title: 'Shortcut löschen',
	favorite_dialog_button_color: 'Button-Farbe',
	favorite_dialog_button_label: 'Button-Beschriftung',
	favorite_dialog_button_label_placeholder: 'z.B. Wichtige E-Mails',
	favorite_dialog_cancel: 'Abbrechen',
	favorite_dialog_color_tab_extended: 'Erweitert',
	favorite_dialog_color_tab_gradient: 'Verlauf',
	favorite_dialog_color_tab_palette: 'Palette',
	favorite_dialog_color_tab_rgb: 'RGB',
	favorite_dialog_color_tab_standard: 'Standard',
	favorite_dialog_display_in_results: 'Anzeige in Suchergebnissen',
	favorite_dialog_display_inline_explanation: 'Shortcut ersetzt passende Textteile direkt im Text',
	favorite_dialog_display_mode_inline: 'Inline ersetzen',
	favorite_dialog_display_mode_none: 'Nicht anzeigen',
	favorite_dialog_display_mode_separate: 'Separater Bereich',
	favorite_dialog_display_none_explanation: 'Shortcut wird nicht in Suchergebnissen angezeigt',
	favorite_dialog_display_separate_explanation: 'Shortcut wird als separater Chip in der großen Ansicht angezeigt',
	favorite_dialog_hex_value: 'Hex-Wert',
	favorite_dialog_preview: 'Vorschau:',
	favorite_dialog_save: 'Als Shortcut speichern',
	favorite_dialog_search_term_label: 'Suchbegriff',
	favorite_dialog_title: 'Suche als Shortcut speichern',
	favorite_display_disabled_explanation: 'Reine Ausschlussfilter können nicht in Ergebnissen angezeigt werden',
	filter_component_active_users: 'Aktive Benutzer',
	filter_component_box_invalid_tooltip: 'Box hat keine gültige ID und kann nicht gefiltert werden',
	filter_component_boxes_filter: 'Boxen',
	filter_component_boxes_placeholder: 'Alle Boxen',
	filter_component_boxes_selected: '{count} ausgewählt',
	filter_component_clear_all_filters: 'Alle Filter zurücksetzen',
	filter_component_custom_range: 'Eigene…',
	filter_component_direction_filter: 'Richtung',
	filter_component_inactive_users: 'Deaktivierte Benutzer',
	filter_component_label: 'Filter',
	filter_component_list_filter: 'Listen',
	filter_component_module_filter: 'Module',
	filter_component_none: 'Keiner',
	filter_component_select_all: 'Alle',
	filter_component_this_month: 'Dieser Monat',
	filter_component_this_week: 'Diese Woche',
	filter_component_timerange_filter: 'Zeitraum',
	filter_component_today: 'Heute',
	filter_component_unknown_user: 'Benutzer {id}',
	filter_component_user_filter: 'Benutzer',
	filter_component_users_placeholder: 'Alle Benutzer',
	filter_component_users_search_empty: 'Kein Benutzer gefunden',
	filter_component_users_search_placeholder: 'Benutzer suchen…',
	filter_component_users_selected: '{count} ausgewählt',
	filter_component_virtual_groups: 'Virtuelle Gruppen',
	filter_component_yesterday: 'Gestern',
	filter_mobile_no_list: 'Keine Liste',
	search_clear_all_tooltip: 'Alles löschen (Favoriten und Suchbegriff)',
	search_clear_favorites_tooltip: 'Favoriten löschen',
	search_clear_tooltip: 'Suchtext löschen',
	search_history_clear_all: 'Alle Suchen löschen',
	search_history_clear_tooltip: 'Suchhistorie für dieses Modul leeren',
	search_history_days_ago: 'vor {days} Tag',
	search_history_days_ago_plural: 'vor {days} Tagen',
	search_history_hours_ago: 'vor {hours} Std',
	search_history_just_now: 'Gerade eben',
	search_history_minutes_ago: 'vor {minutes} Min',
	search_history_no_entries_tooltip: 'Keine Suchhistorie vorhanden',
	search_history_open_tooltip: 'Suchhistorie öffnen ({count} Einträge)',
	search_history_recent_searches: 'Letzte Suchen',
	search_in_instance_placeholder: 'In {name} suchen...',
	search_placeholder_agenda: 'Termine durchsuchen...',
	search_placeholder_default: 'Suchen...',
	search_placeholder_documents: 'Dokumente durchsuchen...',
	search_placeholder_ido_activity_history: 'Aktivitätenhistorie durchsuchen...',
	search_placeholder_inbox: 'Inbox durchsuchen...',
	search_placeholder_mails: 'E-Mails durchsuchen...',
	search_placeholder_messages: 'Nachrichten durchsuchen...',
	search_placeholder_notes: 'Merkzettel durchsuchen...',
	search_placeholder_phonecalls: 'Anrufe durchsuchen...',
	search_placeholder_records: 'Über alle Akten suchen...',
	search_placeholder_tasks: 'Aufgaben durchsuchen...',
	search_placeholder_trash: 'Papierkorb durchsuchen...',
	shortcut_add_to_shortcuts: 'Zu Shortcuts hinzufügen',
	shortcut_edit: 'Shortcut bearbeiten',
	shortcut_picker_filter_placeholder: 'Shortcuts durchsuchen...',
	shortcut_picker_label: 'Shortcuts',
	shortcut_picker_no_results: 'Keine Shortcuts gefunden',
	shortcut_picker_row_menu_label: 'Optionen',
	shortcut_remove_from_shortcuts: 'Aus Shortcuts entfernen',
	shortcut_sync_error:
		'Shortcuts konnten nicht mit dem Server synchronisiert werden. Änderungen werden nur lokal gespeichert.',
};
